import { Controller } from "@hotwired/stimulus"

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

export default class extends Controller {
  static targets = ["display", "input"]

  format() {
    const [y, m, d] = this.inputTarget.value.split("-").map(Number)
    this.displayTarget.value = d ? `${d} ${MONTHS[m - 1]} ${y}` : ""
    setTimeout(() => this.inputTarget.blur(), 0)
  }
}
